import EventEmitter from "../utils/EventEmitter";

export default class SelectSimple extends EventEmitter {
    constructor(element) {
        super();
        this.el = element

        this.select = this.el.querySelector('select')
        this.label = this.el.querySelector('label')

        // inject svg symbol chevron-down in el
        this.el.insertAdjacentHTML('beforeend', '<svg class="icon"><use xlink:href="#chevron-down"></use></svg>')

        if (this.select.options[this.select.selectedIndex].value === 'All') {
            this.el.classList.remove('has-value')
        } else {
            this.el.classList.add('has-value')
        }

        this.select.addEventListener('change', (e) => {

            if (this.select.options[this.select.selectedIndex].value === 'All') {
                this.el.classList.remove('has-value')
            } else {
                this.el.classList.add('has-value')
            }

            this.trigger('selectHasChanged')
        })
    }

    destroy() {
        this.select.removeEventListener('change', (e) => {
            this.trigger('selectHasChanged')
        })
    }
}
